<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .cta-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(4px);

    .cta-label {
      overflow: hidden;
      text-overflow: ellipsis;
      color: colors.get(textBlack);
      @include mixins.body4();
    }
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Components
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";

  // Get store from context
  const { activePopUpModalStore, candidateStore, itemStore } =
    getContext(CONTACT_CTAS_CONTEXT);

  const openModal = () => {
    activePopUpModalStore.set({
      modal: "addToCampaign",
      actionedFrom:
        $itemStore?.kind === "opportunity" ? "opportunityModal" : "",
      candidates: [$candidateStore],
      callback: () => activePopUpModalStore.set(null), // To close the modal after action
    });
  };
</script>

<div class="cta-wrapper">
  <ButtonWithTooltip
    kind="secondary"
    class=""
    leadingIcon=""
    trailingIcon=""
    size="candidate-cta"
    placement="top"
    onclick={openModal}
  >
    <span slot="tooltip">Add contact to a campaign</span>
    <IconScale class="fa-regular fa-megaphone" size="medium" />
  </ButtonWithTooltip>
  <span class="cta-label">Campaign</span>
</div>
